/**
 * How the web portal's loader looks (components/common/LoadingSpinner.web.tsx, design B chosen
 * 2 Nov 2026): the school crest breathing while rings ripple out. No React here, so the rules
 * are tested in Node.
 */

export interface LoaderOptions {
  size?: 'small' | 'large';
  fullScreen?: boolean;
  /** The OS "reduce motion" setting. */
  reducedMotion?: boolean;
}

export interface LoaderLook {
  /** On the navy band (a whole page loading) rather than the page's own colours. */
  onBand: boolean;
  /** The white disc the crest sits in, in pixels. */
  disc: number;
  /** The crest inside it. */
  crest: number;
  /** Room for the rings to grow into. */
  stage: number;
  ringWidth: number;
  /** Rings rippling out - none when motion is reduced. */
  rings: number;
  breathe: boolean;
  messageSize: number;
  /** A page or section loading keeps some height, so the page doesn't collapse while it waits. */
  minHeight: number;
}

/** How far a ring grows before it fades (the ripple keyframes). */
export const RING_GROWTH = 1.9;

export function loaderLook({ size = 'large', fullScreen = false, reducedMotion = false }: LoaderOptions): LoaderLook {
  const disc = fullScreen ? 84 : size === 'small' ? 30 : 60;
  return {
    onBand: fullScreen,
    disc,
    crest: Math.round(disc * 0.72),
    stage: Math.ceil(disc * RING_GROWTH) + 4,
    ringWidth: !fullScreen && size === 'small' ? 1.5 : 2,
    rings: reducedMotion ? 0 : 2,
    breathe: !reducedMotion,
    messageSize: !fullScreen && size === 'small' ? 12 : 13,
    // Full screen fills the window anyway; a small loader sits in a panel that has its own size.
    minHeight: !fullScreen && size === 'large' ? 240 : 0,
  };
}
